import { useEffect, useState } from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import GridColumn_SettingActions from "../../Actions/GridColumn_SettingActions";
import gridColSettingStore from "../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../Constants/GridColumn_SettingConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import { StrictModeDroppable } from "../../helpers/strictModeDragDropHelper";
const checkBoxName = ["show", "sort", "filter"];

export default function GridColumnSettingControl(props) {
  const { pageId, handleCloseModel } = props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [columnSettingList, setColumnSettingList] = useState([]);
  const [popOverVisible, setPopOverVisible] = useState(false);
  const { localization } = useLanguageContext();

  const handleDrop = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;

    var updatedList = [...columnSettingList];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    setColumnSettingList(updatedList);
  };

  useEffect(() => {
    if (pageId !== "") {
      GridColumn_SettingActions.getColumnSetting(
        sessionStorage.getItem("eqGId"),
        pageId,
      );
    }
  }, []);

  useEffect(() => {
    function getColSettingSuccess() {
      var res = gridColSettingStore.getGridColSetting();
      if (res.length > 0) {
        setColumnSettingList(res);
        setPopOverVisible(true);
        setGlobalSpinner(false);
      } else {
        setGlobalSpinner(false);
      }
    }

    function getColSettingFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_COL_SETTING_SUCCESS,
      getColSettingSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_COL_SETTING_FAILURE,
      getColSettingFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_COL_SETTING_SUCCESS,
        getColSettingSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_COL_SETTING_FAILURE,
        getColSettingFailure,
      );
    };
  }, []);

  function handlecheckBoxClick(nameCheckBox, item) {
    let items = [];
    columnSettingList.map((listItem) => {
      if (listItem.name === item.name) {
        if (nameCheckBox === "show" && listItem["show"] === true) {
          listItem["filter"] = false;
          listItem["show"] = false;
        } else {
          listItem[nameCheckBox] = listItem[nameCheckBox] ? false : true;
        }
        items.push(listItem);
      } else {
        items.push(listItem);
      }
    });
    setColumnSettingList(items);
  }

  function handleClose() {
    handleCloseModel();
  }

  function handleSaveSetting() {
    let saveObj = columnSettingList.map((item, index) => {
      return {
        Name: item.name,
        Position: index + 1,
        Show: item.name === "ID" ? true : item.show,
        Filter: item.filter,
        Sort: item.sort,
      };
    });
    let SaveDataModel = {
      ReportCode: pageId,
      EquipmentGroupId: sessionStorage.getItem("eqGId"),
      GridColumns: saveObj,
    };
    setGlobalSpinner(true);

    GridColumn_SettingActions.saveGridColumnSetting(SaveDataModel);
  }

  return (
    <>
      {popOverVisible && (
        <div
          className="modal in "
          id="MsgModalCenter"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="MsgModalCenterTitle"
          aria-hidden="true"
          style={{ opacity: "1", display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="container">
                  <div className="row">
                    <div className="col-10  pl-0">
                      {localization.popOverHeader}
                    </div>
                    <div className="col-2">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-body pl-1 pr-1">
                <DragDropContext onDragEnd={handleDrop}>
                  <StrictModeDroppable droppableId="container">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <div
                          className="container pl-5 pr-5 pt-4"
                          style={{
                            maxHeight: "57vh",
                            overflowY: "scroll",
                            overflowX: "hidden",
                          }}
                        >
                          {columnSettingList.map((item, index) => (
                            <Draggable
                              key={item.name}
                              draggableId={item.name}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.dragHandleProps}
                                  {...provided.draggableProps}
                                >
                                  {item.name !== "ID" && (
                                    <div
                                      className="row d-flex list-group-item  mb-1 bt-0"
                                      key={index + 1}
                                    >
                                      <div className="col">
                                        <label>{item.text}</label>
                                      </div>
                                      <div className="col d-flex justify-content-end">
                                        <input
                                          type="checkBox"
                                          id={checkBoxName[0] + index}
                                          name={checkBoxName[0]}
                                          disabled={false}
                                          defaultChecked={item.show}
                                          onChange={(e) => {
                                            handlecheckBoxClick(
                                              checkBoxName[0],
                                              item,
                                            );
                                          }}
                                        />

                                        <label className="mt-2 ml-1">
                                          {localization.show}
                                        </label>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        </div>

                        {provided.placeholder}
                      </div>
                    )}
                  </StrictModeDroppable>
                </DragDropContext>
              </div>
              <div className="modal-footer justify-content-end">
                <div className="form-group d-flex ">
                  <button
                    type="button"
                    className="btn btn-secondary btn-block mb-4 mr-4 mt-2 "
                    onClick={handleClose}
                  >
                    {localization.cancel}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-block mb-4 mr-4"
                    onClick={handleSaveSetting}
                  >
                    {localization.apply}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
